import Request from '../Request.utils'
export interface IPairRequestBody {
  machineName?: string | '' | null;
  name?: string | '' | null;
  pairingCode: string;
  supportedFormats?: string[];
  version?: string | '' | null;
}
export interface IHeartbeatRequestBody {
  printerName?: string | '' | null;
  status?: string | '' | null;
  supportedFormats?: string[];
  version?: string | '' | null;
}
export interface IJobsNextRequestQuery {
  timeoutSeconds?: number;
}
export interface IJobsClaimRequestBody {
  /**
   * Unknown Property
   */
  [x: string]: unknown;
}
export interface IJobsClaimRequestParams {
  jobId: string;
}
export interface IJobsManifestRequestParams {
  jobId: string;
}
export interface IJobsDocumentRequestParams {
  documentId: string;
  jobId: string;
}
export interface IJobsEventsRequestBody {
  /**
   * Unknown Property
   */
  [x: string]: unknown;
  bytesWritten?: number;
  documentId?: string;
  errorCode?: string | '' | null;
  errorMessage?: string | '' | null;
  sequence?: number;
  spoolerJobId?: string | '' | null;
  status?: string;
}
export interface IJobsEventsRequestParams {
  jobId: string;
}
export interface IJobsCompleteRequestBody {
  /**
   * Unknown Property
   */
  [x: string]: unknown;
  documents?: any[];
  errorCode?: string | '' | null;
  errorMessage?: string | '' | null;
  status?: string;
}
export interface IJobsCompleteRequestParams {
  jobId: string;
}
export interface IRevokeRequestParams {
  id: string;
}
export interface ITestJobRequestParams {
  id: string;
}


class PrintConnectorAPI {
  pair = async (body: IPairRequestBody) => {
    const res = await Request.call('/api/print-connector/pair', 'POST', undefined, undefined, body, );
    return res;
  }
  heartbeat = async (body: IHeartbeatRequestBody) => {
    const res = await Request.call('/api/print-connector/heartbeat', 'POST', undefined, undefined, body, );
    return res;
  }
  jobsNext = async (query: IJobsNextRequestQuery) => {
    const res = await Request.call('/api/print-connector/jobs/next', 'GET', undefined, query, undefined, );
    return res;
  }
  jobsClaim = async (params: IJobsClaimRequestParams, body: IJobsClaimRequestBody) => {
    const res = await Request.call('/api/print-connector/jobs/:jobId/claim', 'POST', params, undefined, body, );
    return res;
  }
  jobsManifest = async (params: IJobsManifestRequestParams) => {
    const res = await Request.call('/api/print-connector/jobs/:jobId/manifest', 'GET', params, undefined, undefined, );
    return res;
  }
  jobsDocument = async (params: IJobsDocumentRequestParams) => {
    const res = await Request.call('/api/print-connector/jobs/:jobId/documents/:documentId', 'GET', params, undefined, undefined, );
    return res;
  }
  jobsEvents = async (params: IJobsEventsRequestParams, body: IJobsEventsRequestBody) => {
    const res = await Request.call('/api/print-connector/jobs/:jobId/events', 'POST', params, undefined, body, );
    return res;
  }
  jobsComplete = async (params: IJobsCompleteRequestParams, body: IJobsCompleteRequestBody) => {
    const res = await Request.call('/api/print-connector/jobs/:jobId/complete', 'POST', params, undefined, body, );
    return res;
  }
  pairingSessions = async () => {
    const res = await Request.call('/api/print-connectors/pairing-sessions', 'POST', undefined, undefined, undefined, );
    return res;
  }
  list = async () => {
    const res = await Request.call('/api/print-connectors', 'GET', undefined, undefined, undefined, );
    return res;
  }
  revoke = async (params: IRevokeRequestParams) => {
    const res = await Request.call('/api/print-connectors/:id/revoke', 'POST', params, undefined, undefined, );
    return res;
  }
  testJob = async (params: ITestJobRequestParams) => {
    const res = await Request.call('/api/print-connectors/:id/test-job', 'POST', params, undefined, undefined, );
    return res;
  }
}
export default new PrintConnectorAPI()